import React from 'react';
import { useParams } from 'react-router-dom';
import { IonPage, IonContent } from '@ionic/react';
import { CallDetail } from '../components/mystery-shop/call-detail';
import revLogo from '../assets/REV_logo.svg';

const MysteryShopCallPage: React.FC = () => {
  const { callId } = useParams<{ callId: string }>();

  return (
    <IonPage>
      <IonContent className="bg-white">
        <div className="min-h-screen bg-white">
          <main className="max-w-3xl mx-auto px-6 bg-gray-50 min-h-screen">
            <div className="flex items-center justify-center gap-3 py-6">
              <img src={revLogo} alt="REV Logo" className="h-8 w-auto" />
              <span className="text-xl font-semibold text-black">REV Leasing</span>
            </div>
            <div className="pb-8">
              <CallDetail callId={callId} />
            </div>
          </main>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default MysteryShopCallPage;
